var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BContainer',{staticClass:"h-100 px-0",attrs:{"fluid":""}},[_c('div',{staticClass:"h-100 d-flex"},[_c('div',{staticClass:"m-auto fr-center-card"},[_c('BounceLoader',{attrs:{"color":_vm.loadingColor}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }